module.exports = __webpack_public_path__ + "img/VsLotion6.e859304a.png";